module.exports = __webpack_public_path__ + "static/media/NatConCol.4b1694de.png";